import './rejectedPage.scss';
import React, { useState, useEffect } from 'react';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import { Search, ArrowBack, CancelOutlined, CheckCircleOutlined } from '@material-ui/icons';

const { REACT_APP_STRAPI_API_URL } = process.env;

function RejectedPage() {
    const [searchDomainTitle, setSearchDomainTitle] = useState();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
                );
                const json = await response.json();
                setSearchDomainTitle(json?.data[0]?.attributes);
            } catch (error) {
            }
        };
        fetchData();
    }, []);

    const [buttons, setButton] = useState();
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${REACT_APP_STRAPI_API_URL}/api/button-apis`
                );
                const json = await response.json();
                setButton(json?.data[0]?.attributes);
            } catch (error) {
            }
        };
        fetchData();
    }, []);
    const [usBetters, setUsBetter] = useState()
    const getUsBetterData = async () => {
        const response = await fetch(
            `${REACT_APP_STRAPI_API_URL}/api/us-betters?populate=Image`
        ).then(response => response.json())
        setUsBetter(response?.data)
    }
    useEffect(() => {
        getUsBetterData()
    }, [])


    return (
        <>
            <div class="borderboxwrap">
                <div class="title-col1">
                    <Typography variant="h1">{searchDomainTitle?.title}</Typography>
                </div>
                <form class="searchcolwrap">
                    <input type="search" name="search" placeholder='Search'></input>
                    <Button className="btnSearchRej"><Search></Search>{buttons?.avax}</Button>
                </form>
                <section className='register'>
                    <Container>
                        <Grid item xs={12}>
                            <div className='oops'>
                                <Typography variant="h2">OOPS!</Typography>
                                <Typography variant="h3">{searchDomainTitle?.rejectedDataTitle}</Typography>
                            </div>
                        </Grid>
                        <div className='finishprocess'>
                            <Button className="btnback"><ArrowBack></ArrowBack>{buttons?.back}</Button>
                        </div>
                        <Grid style={{ display: "flex", flexWrap: "wrap" }}>
                            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                                <div className='registerCard'>
                                    <div>
                                        <CheckCircleOutlined></CheckCircleOutlined>
                                        <div className='iconcirclecol'></div>
                                        <Typography variant="h4">Start to register</Typography>
                                        <Typography component="p">Your wallet will open and you will be asked to confirm the first of two transactions
                                            required for registration. If the second transaction is not processed within 24 hours of the first, you will need to start again from step 1.</Typography>
                                    </div>
                                </div>
                            </Grid>
                            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                                <div className='registerCard'>
                                    <div>
                                        <CheckCircleOutlined></CheckCircleOutlined>
                                        <div className='iconcirclecol'></div>
                                        <Typography variant="h4">Wait One Minute</Typography>
                                        <Typography component="p">The waiting period is required to ensure another person hasn't tried to register the same name and protect you after your request.</Typography>
                                    </div>
                                </div>
                            </Grid>
                            <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                                <div className='registerCard'>
                                    <div>
                                        <CancelOutlined></CancelOutlined>
                                        <div className='iconcirclecol1'></div>
                                        <Typography variant="h4">Transaction Rejected</Typography>
                                        <Typography component="p">Your transaction did not go through, please try again.</Typography>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Container>
                </section>
                <section className="usBetter">
                    <Container>
                        <Grid item xs={12}>
                            <Typography variant="h1">{searchDomainTitle?.usbetterTitle}</Typography>
                        </Grid>
                        <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {usBetters &&
                                usBetters.map(usBetter => (
                                    <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                                        <div className="usBetterDetail">
                                            <img
                                                src={
                                                    REACT_APP_STRAPI_API_URL +
                                                    usBetter?.attributes?.Image?.data[0]?.attributes.url
                                                }
                                                alt=" "
                                                class="img-fluid"
                                            />
                                            <Typography variant="h2">{usBetter.attributes.name}</Typography>
                                            <Typography component="p">{usBetter.attributes.content}</Typography>
                                        </div>
                                    </Grid>
                                ))}
                        </Grid>
                    </Container>
                </section>
            </div>
        </>
    );
}

export default RejectedPage;
